/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FaqSetResponse,
  HTTPValidationError
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get an FAQ set by its slug.

Returns an ordered list of FAQs for the specified FAQ set.
FAQ answers are returned as HTML-formatted strings.

Args:
    slug: The FAQ set slug (e.g., "payment-cancer", "payment-multi-disease")

Returns:
    FaqSetResponse with ordered FAQs

Raises:
    404: If the FAQ set is not found
 * @summary Get Faq Set By Slug
 */
export const getFaqSetBySlugV1FaqSetsSlugGet = (
    slug: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<FaqSetResponse>(
      {url: `/v1/faq-sets/${slug}`, method: 'GET', signal
    },
      );
    }
  



export const getGetFaqSetBySlugV1FaqSetsSlugGetQueryKey = (slug?: string,) => {
    return [
    `/v1/faq-sets/${slug}`
    ] as const;
    }

    
export const getGetFaqSetBySlugV1FaqSetsSlugGetQueryOptions = <TData = Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError = HTTPValidationError>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaqSetBySlugV1FaqSetsSlugGetQueryKey(slug);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>> = ({ signal }) => getFaqSetBySlugV1FaqSetsSlugGet(slug, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFaqSetBySlugV1FaqSetsSlugGetQueryResult = NonNullable<Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>>
export type GetFaqSetBySlugV1FaqSetsSlugGetQueryError = HTTPValidationError


export function useGetFaqSetBySlugV1FaqSetsSlugGet<TData = Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError = HTTPValidationError>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>,
          TError,
          Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFaqSetBySlugV1FaqSetsSlugGet<TData = Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>,
          TError,
          Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFaqSetBySlugV1FaqSetsSlugGet<TData = Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Faq Set By Slug
 */

export function useGetFaqSetBySlugV1FaqSetsSlugGet<TData = Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError = HTTPValidationError>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaqSetBySlugV1FaqSetsSlugGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFaqSetBySlugV1FaqSetsSlugGetQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




